import React from 'react';
import { useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import theme from '@src/styles/theme';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import sanitizeHtml from 'sanitize-html';
import { StyledApiPackageConversionNotification } from './index.style';

const ApiPackageConversionNotification = () => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down('smd'));

  return (
    <StyledApiPackageConversionNotification isMobile={isMobile}>
      <div className="notification-content">
        <InfoRoundedIcon className="info-icon" />
        <Typography
          variant="body-14-regular"
          color={COLOR.darkGray}
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(
              t('apiPackageConversionMessage', {
                link: 'https://help.vbee.vn/docs/thong-bao/ban-cap-nhat-thang-01-2026',
              }),
              {
                allowedTags: ['a'],
                allowedAttributes: { a: ['href', 'style', 'target'] },
              },
            ),
          }}
        />
      </div>
    </StyledApiPackageConversionNotification>
  );
};

export default ApiPackageConversionNotification;
